import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { DataGrid, esES } from "@mui/x-data-grid";
import axios from "helpers/API";

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: "relative",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function FullScreenDialog({ show = false, handleShow, id = false }) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [rows, setRows] = React.useState([]);

    React.useEffect(() => {
        if (show) {
            setOpen(true);
            handleShow(false);
        }
    }, [show]);

    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {
        if (id) {
            getDetalles(id);
        }
    }, [id]);

    const getDetalles = (id) => {
        axios
            .post("/programaciones/obtenerDetalles", { id: id })
            .then(function (response) {
                // Le agrego id por ser obligatorio para la tabla
                const detalles = response.data.map((detalle, index) => {
                    return {
                        ...detalle,
                        id: index,
                    };
                });
                setRows(detalles);
            })
            .catch(function (error) {
                //console.log(error);
            });
    };

    const columns = [
        { field: "id", headerName: "ID", hide: true, flex: 0.4 },
        {
            field: "servidor",
            headerName: "Servidor",
            minWidth: 30,
            flex: 1,
            editable: false,
        },
        {
            field: "cantTurnos",
            headerName: "Cant. Turnos",
            minWidth: 150,
            flex: 1,
            editable: false,
        },
        {
            field: "fechaTurno",
            headerName: "Fecha Turno",
            minWidth: 150,
            flex: 1,
            editable: false,
        },
        {
            field: "horaTurno",
            headerName: "Hora Turno",
            minWidth: 150,
            flex: 1,
            editable: false,
        },
        {
            field: "activo",
            headerName: "Activo",
            minWidth: 150,
            flex: 1,
            editable: false,
        },
    ];

    return (
        <div>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                            Detalle Programación
                        </Typography>
                        <Button autoFocus color="inherit" onClick={handleClose}>
                            Cerrar
                        </Button>
                    </Toolbar>
                </AppBar>
                <DataGrid
                    localeText={esES.props.MuiDataGrid.localeText}
                    rows={rows}
                    columns={columns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    checkboxSelection
                    disableSelectionOnClick
                />
            </Dialog>
        </div>
    );
}

export default FullScreenDialog;
